<template>
  <div
    class="transition opacity-50 hover:opacity-100 focus-within:opacity-100 p-4 sm:p-6 rounded-lg bg-gray-600 text-gray-200  "
    :class="{ active: isActive, 'opacity-100': noneActive }"
    @click.stop="enabled ? setFocus() : ''"
    @focus.stop="enabled ? setFocus() : ''"
    @blur.capture="blurred()"
    :key="`invoiceItem-${invoiceId}-${productId}`"
  >
    <!-- active:bg-gray-500 active:text-gray-800 focus-within:bg-gray-500 focus-within:text-gray-800 -->
    <div class="text-2xl font-bold leading-none focus:outline-none">
      {{ productName(productId) }}
    </div>
    <div class="w-full" v-show="enabled">
      <div class="flex flex-wrap">
        <div
          class="mt-4 pr-2 sm:pr-3 flex flex-col justify-end"
          :class="[
            (valueLocal.action &&
              valueLocal.action === 'Discrepancy: Wrong Number Received') ||
            (valueLocal.action && valueLocal.action.slice(0, 8) === 'Returned')
              ? 'w-1/3'
              : 'w-1/2'
          ]"
        >
          <label
            class="
              block
              uppercase
              tracking-wide
              text-xs
              font-bold
              mb-2 leading-none"
            :for="`inputTotalCost_${invoiceId}_${productId}`"
          >
            Individual Unit Price
          </label>
          <money
            class="focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            :ref="`inputTotalCost_${invoiceId}_${productId}`"
            :id="`inputTotalCost_${invoiceId}_${productId}`"
            v-model.lazy="valueLocal.cost"
            @click.stop
            @focus.native.stop="$emit('focused', index)"
            v-bind="moneyConfig"
            autocomplete="off"
          />
        </div>

        <div
          class="mt-4 pl-2 sm:pl-3 flex flex-col justify-end"
          :class="[
            (valueLocal.action &&
              valueLocal.action === 'Discrepancy: Wrong Number Received') ||
            (valueLocal.action && valueLocal.action.slice(0, 8) === 'Returned')
              ? 'w-1/3 pr-2 sm:pr-3'
              : 'w-1/2'
          ]"
        >
          <label
            class="block uppercase tracking-wide text-xs font-bold mb-2 leading-none"
            :for="`inputAmountReceived_${invoiceId}_${productId}`"
          >
            Amount Received
          </label>
          <input
            class="focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            :ref="`inputAmountReceived_${invoiceId}_${productId}`"
            :id="`inputAmountReceived_${invoiceId}_${productId}`"
            v-model.lazy="valueLocal.amountReceived"
            type="number"
            min="0"
            @click.stop
            @focus.stop="$emit('focused', index)"
            placeholder="Required"
            autocomplete="off"
          />
        </div>

        <!-- <transition name="fade" mode="out-in"> -->
        <div
          class="w-1/3 mt-4 pl-2 sm:pl-3 flex flex-col justify-end"
          v-if="
            valueLocal.action && valueLocal.action.slice(0, 8) === 'Returned'
          "
        >
          <label
            class="block uppercase tracking-wide text-xs font-bold mb-2 leading-none"
            :for="`inputAmountReturned_${invoiceId}_${productId}`"
          >
            Amount Returned
          </label>
          <input
            class="focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            :ref="`inputAmountReturned_${invoiceId}_${productId}`"
            :id="`inputAmountReturned_${invoiceId}_${productId}`"
            v-model.lazy="valueLocal.amountReturned"
            type="number"
            min="0"
            @click.stop
            @focus.stop="$emit('focused', index)"
            placeholder="Required"
            autocomplete="off"
          />
          <!-- transition-duration -->
          <!-- <input type="file" id="take-picture" accept="image/*"> -->
        </div>
        <!-- </transition>
        <transition
          name="slide-fade"
          mode="out-in"
        > -->
        <div
          class="w-1/3 mt-4 pl-2 sm:pl-3 flex flex-col justify-end"
          v-if="
            valueLocal.action &&
              valueLocal.action === 'Discrepancy: Wrong Number Received'
          "
        >
          <label
            class="block uppercase tracking-wide text-xs font-bold mb-2"
            :for="`inputAmountBilled_${invoiceId}_${productId}`"
          >
            Amount Billed
          </label>
          <input
            class="focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            :ref="`inputAmountBilled_${invoiceId}_${productId}`"
            :id="`inputAmountBilled_${invoiceId}_${productId}`"
            v-model.lazy="valueLocal.amountBilled"
            type="number"
            min="0"
            @click.stop
            @focus.stop="$emit('focused', index)"
            placeholder="Required"
            autocomplete="off"
          />
        </div>
        <!-- </transition> -->
      </div>
      <div class="w-full mt-4">
        <label
          class="block uppercase tracking-wide text-xs font-bold mb-2"
          :for="`inputInvoiceAction_${invoiceId}_${productId}`"
        >
          Invoice Action
        </label>
        <div class="relative">
          <select
            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline focus:bg-white focus:border-gray-500"
            :id="`inputInvoiceAction_${invoiceId}_${productId}`"
            :ref="`inputInvoiceAction_${invoiceId}_${productId}`"
            @click.stop
            @focus.stop="$emit('focused', index)"
            v-model="valueLocal.action"
          >
            <option
              v-for="action in settingsInvoiceActions"
              :key="action"
              v-text="action"
            />
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
              />
            </svg>
          </div>
        </div>
      </div>
      <div
        class="w-full mt-4"
        v-if="
          valueLocal.action &&
            (valueLocal.action.slice(0, 8) === 'Returned' ||
              valueLocal.action.slice(0, 11) === 'Discrepancy')
        "
      >
        <label
          class="block uppercase tracking-wide text-xs font-bold mb-2"
          :for="`inputReturnReason_${invoiceId}_${productId}`"
        >
          Additional Information
        </label>
        <input
          v-model.lazy="valueLocal.returnReason"
          class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline focus:bg-white focus:border-gray-500"
          :id="`inputReturnReason_${invoiceId}_${productId}`"
          :ref="`inputReturnReason_${invoiceId}_${productId}`"
          @click.stop
          @focus.stop="$emit('focused', index)"
          type="text"
          placeholder="ex. Shipment arrived damaged."
          autocomplete="none"
        />
      </div>
      <!-- <div
        class="w-full mt-4"
        v-if="valueLocal.action && valueLocal.action.slice(0, 8) === 'Returned'"
      >
        <label
          class="block uppercase tracking-wide text-xs font-bold mb-2"
          :for="`inputAmountReturned_${invoiceId}_${index}`"
        >
          Amount Returned
        </label>
        <input
          class="focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          :ref="`inputAmountReturned_${invoiceId}_${index}`"
          :id="`inputAmountReturned_${invoiceId}_${index}`"
          v-model.lazy="valueLocal.amountReturned"
          type="number"
          min="0"
          @click.stop
          @focus.stop="$emit('focused', index)"
          placeholder="Required"
          autocomplete="off"
        />
      </div>
      <div
        class="w-full mt-4"
        v-if="
          valueLocal.action &&
            valueLocal.action === 'Discrepancy: Wrong Number Received'
        "
      >
        <label
          class="block uppercase tracking-wide text-xs font-bold mb-2"
          :for="`inputAmountBilled_${invoiceId}_${index}`"
        >
          Amount Billed
        </label>
        <input
          class="focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          :ref="`inputAmountBilled_${invoiceId}_${index}`"
          :id="`inputAmountBilled_${invoiceId}_${index}`"
          v-model.lazy="valueLocal.amountBilled"
          type="number"
          min="0"
          @click.stop
          @focus.stop="$emit('focused', index)"
          placeholder="Required"
          autocomplete="off"
        />
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { isEqual } from 'lodash'
import { Money } from 'v-money'
import { floatify } from '@/utils'
// import TransitionExpand from '@/components/TransitionExpand'

export default {
  name: 'InvoiceItem',
  props: {
    index: {
      type: Number,
      required: true
    },
    activeItem: {
      type: Number,
      required: false,
      default: null
    },
    invoiceId: {
      type: String,
      required: true
    },
    productId: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      valueLocal: {
        // amountEntered: 0, amount copied from server
        cost: 0,
        amountReceived: 0,
        amountBilled: 0,
        action: null,
        returnReason: null,
        amountReturned: 0,
        totalCost: 0
      },
      valueOnLastBlur: {
        // amountEntered: 0 amount copied from server
        cost: 0,
        amountReceived: 0,
        amountBilled: 0,
        action: null,
        returnReason: null,
        amountReturned: null,
        totalCost: 0
      },
      wasFocused: false,
      wasBlurred: false,
      moneyConfig: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        suffix: '',
        precision: 2,
        masked: false /* doesn't work with directive */
      }
    }
  },
  components: {
    Money
    // TransitionExpand
  },
  computed: {
    ...mapGetters('global', ['settingsInvoiceActions']),
    ...mapGetters('storeModule/products', ['productName']),
    ...mapGetters('storeModule/invoices', [
      'invoiceById',
      'productByInvoiceIdByProductId'
    ]),
    isActive() {
      return this.activeItem === this.index
    },
    noneActive() {
      return this.activeItem === -1
    },
    invoiceItem() {
      return this.productByInvoiceIdByProductId(this.invoiceId)(this.productId)
    },
    amountOrdered() {
      return this.invoiceItem.amountOrdered
    },
    enabled() {
      return (
        this.invoiceItem.amountOrdered > 0 ||
        this.invoiceItem.amountOrdered == false
      )
    },
    amountReceived() {
      return parseInt(this.valueLocal.amountReceived)
    },
    amountBilled() {
      if (
        this.valueLocal.action &&
        this.valueLocal.action === 'Discrepancy: Wrong Number Received'
      )
        return parseInt(this.valueLocal.amountBilled, 10)
      else return parseInt(this.valueLocal.amountReceived, 10)
    },
    amountReturned() {
      if (
        this.valueLocal.action &&
        this.valueLocal.action.slice(0, 8) === 'Returned'
      )
        return parseInt(this.valueLocal.amountReturned, 10)
      else return 0
    },
    totalCost() {
      return this.valueLocal.action === 'Canceled'
        ? 0
        : floatify(parseFloat(this.valueLocal.cost) * this.amountBilled)
    }
  },
  watch: {
    totalCost() {
      this.valueLocal.totalCost = this.totalCost
    },
    isActive(newValue) {
      console.log(
        `'isActive' for ${this.productName(
          this.productId
        )} changed to: ${newValue}`
      )
      this.wasFocused = true
      this.wasBlurred = !newValue
      newValue ? console.log(this.productName(this.productId)) : ''

      // this.$refs[`invoice-${event.invoiceId}`][0].$refs[
      //         `invoice-items-${event.invoiceId}`
      //       ].$refs[
      //         `invoice-item-${event.invoiceId}-${event.productId}`
      //       ][0].$el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    },
    wasBlurred(newValue) {
      if (newValue) this.putValue()
    },
    invoiceItem: {
      immediate: true,
      handler(newValue) {
        if (!isEqual(this.valueLocal, newValue)) {
          if (typeof newValue === 'object') this.valueLocal = newValue
          else this.valueLocal.amountOrdered = newValue
          if (this.valueLocal.cost == null) this.valueLocal.cost = 0
        }
      }
    }
  },
  methods: {
    ...mapActions('storeModule/invoices', ['updateItem']),
    // onFocus(ref = 'inputTotalCost') {
    //   if (!this.isActive) this.$emit('focused', this.index)
    //   this.setFocus(ref)
    // },
    setFocus(ref = 'inputTotalCost') {
      console.log(`Setting focus for: ${this.productName(this.productId)}`)
      console.dir(this.$refs)
      if (!this.isActive) this.$emit('focused', this.index)
      this.$nextTick(() => {
        // scroll to new element
        this.$refs[
          `${ref}_${this.invoiceId}_${this.productId}`
        ].$el.scrollIntoView({ behavior: 'smooth', block: 'center' })

        // set focus on new Product totalCost input,
        // preventScroll: true - allows the smooth scroll from above to finish
        this.$refs[`${ref}_${this.invoiceId}_${this.productId}`].$el.focus({
          preventScroll: true
        })
      })
      // this.$nextTick(() => {
      //   this.$refs[`${ref}_${this.invoiceId}_${this.productId}`].$el.focus()
      // })
    },
    blurred() {
      console.log('blurred')
      this.$emit('focused', -1)
    },
    // receivedFocus() {
    //   this.$emit('focused', this.index)
    // },
    putValue() {
      console.log('InvoiceItem/putValue()')
      // set default action as received if not already set
      if (this.valueLocal.cost && !this.valueLocal.action)
        this.$set(this.valueLocal, 'action', 'Received')

      if (this.valueLocal.action === 'Canceled') {
        this.valueLocal.amountReceived = 0
        this.valueLocal.amountBilled = 0
        this.valueLocal.amountReturned = 0
        this.valueLocal.totalCost = 0
        this.valueLocal.cost = 0
      }

      // if the value changed since last save, update firestore
      if (!isEqual(this.valueOnLastBlur, this.valueLocal)) {
        this.updateItem({
          id: this.invoiceId,
          data: {
            [this.productId]: {
              id: this.productId,
              ...this.valueLocal,
              amountReceived: this.amountReceived,
              amountOrdered: this.amountOrdered,
              amountBilled: this.amountBilled,
              amountReturned: this.amountReturned
            }
          }
        })
        // update saved value for next blur event
        this.valueOnLastBlur = Object.assign({}, this.valueLocal)
      }
    }
  }
}
</script>

<style scoped>
.transition {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 100ms;
}
</style>
